import { render, staticRenderFns } from "./SquarePhotoIcon.vue?vue&type=template&id=10b23950&"
import script from "./SquarePhotoIcon.vue?vue&type=script&lang=js&"
export * from "./SquarePhotoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports